import React, { Component } from 'react';
import { connect } from "react-redux";
import { compose } from "redux";
import { Link, withRouter } from "react-router-dom";
import uuid from "react-uuid";
import ApiService from "../../Services/apiService";
import TranslationService from '../../Services/translationService';
import AlertService from "../../Services/alertService";
import Carousel from "../../Components/Carousel/carousel";
import Auxiliary from '../../hoc/auxiliary/auxiliary';
import CourseBlock from '../../Components/Course/courseBlock';
import NukaCarousel from 'nuka-carousel';
import cryllex from '../../assets/images/cryllex.svg';
import getmepet from '../../assets/images/getmepet.svg';
import frantixmedia from '../../assets/images/frantixmedia.svg';
import { setPureLayoutBackUrl } from './../../Store/Actions/main';
import { addButtonSpinner, removeButtonSpinner, addPageSpinner, removePageSpinner } from "../../Store/Actions/spinner";
import { setCurrentCourse } from "../../Store/Actions/course";
import { RETURN_URL_KEY, INSTRUCTOR_USER_TYPE, CONSULTANT_USER_TYPE, ERROR_KEY, STUDENT_USER_TYPE } from './../../Constants/mainKeys';
import { CONSULTANT_KEY } from '../../Constants/requestKeys';
import {
  BECOME_CONSULTANT_KEY,
  BECOME_INSTRUCTOR_KEY,
  CATEGORY_KEY,
  CONSULTANT_INFORMATION_KEY,
  COURSES_KEY,
  COURSE_DASHBOARD_KEY,
  FROM_INFO_PAGE_KEY,
  INSTRUCTOR_KEY,
  PURE_KEY,
  VIEW_KEY,
} from '../../Constants/urlKeys';


const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1224 },
    items: 5,
    slidesToSlide: 5,
  },
  tablet: {
    breakpoint: { max: 1224, min: 968 },
    items: 4,
    slidesToSlide: 4,
  },
  smallTablet: {
    breakpoint: { max: 968, min: 725 },
    items: 3,
    slidesToSlide: 3,
  },
  mobile: {
    breakpoint: { max: 725, min: 575 },
    items: 3,
    slidesToSlide: 3
  },
  smallMobile: {
    breakpoint: { max: 575, min: 0 },
    items: 2,
    slidesToSlide: 2
  }
};

const responsiveCourses = {
  desktop: {
    breakpoint: { max: 3000, min: 1224 },
    items: 3,
    slidesToSlide: 3,
  },
  tablet: {
    breakpoint: { max: 1224, min: 968 },
    items: 3,
    slidesToSlide: 3,
  },
  smallTablet: {
    breakpoint: { max: 968, min: 725 },
    items: 2,
    slidesToSlide: 2,
  },
  mobile: {
    breakpoint: { max: 725, min: 575 },
    items: 2,
    slidesToSlide: 2
  },
  smallMobile: {
    breakpoint: { max: 575, min: 0 },
    items: 1,
    slidesToSlide: 1
  }
};

class Home extends Component {
  _isMounted = false;

  state = {
    courses: [],
    pageContent: null,
    sliderContent: [],
    translationService: null,

    topCourses: [],
    recommendedCourses: [],
    developmentCourses: [],
    bestsellerCourses: [],
  }

  componentDidMount() {
    this._isMounted = true;
    this.setTranslations();
    if (this.props.user && !this.props.user.isOrganizationUser) {
      this.getHomePagecontent();
      this.getCourses();
    }
    const url = localStorage.getItem(RETURN_URL_KEY);
    if (url && !url.includes(PURE_KEY) && !url.includes(COURSE_DASHBOARD_KEY)) {
      this.redirectToReturnUrlPage(url);
    }
    if (url && url.includes(PURE_KEY) && !url.includes(!FROM_INFO_PAGE_KEY)) this.redirectToInstructorOrConsultantPage(url);
    if (url && url.includes(COURSE_DASHBOARD_KEY)) this.getCourseAndRedirectToGeneralInfo(url);
    if (url && url.includes(FROM_INFO_PAGE_KEY)) this.redirectFromInfoPageUrl(url);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  redirectFromInfoPageUrl = (url) => {
    const { user, language } = this.props;
    if (url.includes(BECOME_INSTRUCTOR_KEY)) {
      user.userTypeId !== STUDENT_USER_TYPE
        ? this.props.history.push(`/${language}/${INSTRUCTOR_KEY}/${COURSES_KEY}/${VIEW_KEY}`)
        : this.props.history.push(`/${language}/${PURE_KEY}/${BECOME_INSTRUCTOR_KEY}`)
    }
    if (url.includes(BECOME_CONSULTANT_KEY)) {
      user.userTypeId === CONSULTANT_USER_TYPE
        ? this.props.history.push(`/${language}/${CONSULTANT_KEY}/${CONSULTANT_INFORMATION_KEY}`)
        : this.props.history.push(`/${language}/${PURE_KEY}/${BECOME_CONSULTANT_KEY}`)
    }
    localStorage.removeItem(RETURN_URL_KEY);
    this.props.setPureLayoutBackUrl(`/${language}`)
  }

  redirectToInstructorOrConsultantPage = (url) => {
    const { user, language } = this.props;
    if (user.userTypeId && (user.userTypeId === INSTRUCTOR_USER_TYPE || user.userTypeId === CONSULTANT_USER_TYPE)) {
      user.userTypeId && user.userTypeId === CONSULTANT_USER_TYPE && url.includes(BECOME_CONSULTANT_KEY) && this.props.history.push(`/${language}/${CONSULTANT_KEY}/${CONSULTANT_INFORMATION_KEY}`);
      user.userTypeId && user.userTypeId === INSTRUCTOR_USER_TYPE && url.includes(BECOME_CONSULTANT_KEY) && this.props.history.push(`/${language}/${PURE_KEY}/${BECOME_CONSULTANT_KEY}`);
      url.includes(BECOME_INSTRUCTOR_KEY) && this.props.history.push(`/${language}/${INSTRUCTOR_KEY}/${COURSES_KEY}/${VIEW_KEY}`);
    } else {
      this.props.history.push(url);
    }
    localStorage.removeItem(RETURN_URL_KEY);
  }

  redirectToReturnUrlPage = (url) => {
    this.props.history.push(url);
    localStorage.removeItem(RETURN_URL_KEY);
  }

  getCourseAndRedirectToGeneralInfo = (url) => {
    const spinnerId = uuid();
    var regex = /\d+/g;
    var courseId = url.match(regex);
    if (courseId && courseId.length && url.includes(COURSE_DASHBOARD_KEY)) {
      this.props.addPageSpinner(spinnerId);
      ApiService.getCourseById(+courseId[0]).then(response => {
        response && response.data && this.setCurrentCourseHandler(response.data, url);
        this.props.removePageSpinner(spinnerId);
        localStorage.removeItem(RETURN_URL_KEY);
      }).catch(error => {
        this.props.removePageSpinner(spinnerId);
        localStorage.removeItem(RETURN_URL_KEY);
        error && AlertService.alert((AlertService.checkMessageType(error.respcode) || ERROR_KEY), error);
        this.props.history.push(`/${this.props.language}`);
      });
    }
  }

  componentDidUpdate() {
    this.setTranslations();
  };

  setCurrentCourseHandler = async (course, url) => {
    await this.props.setCurrentCourse(course);
    this.props.history.push(url);
  };

  setTranslations = () => {
    if (!this.state.translationService && this.props.translations) {
      this._isMounted && this.setState({ translationService: new TranslationService(this.props.translations) });
    };
  };

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.translations
      && JSON.stringify(nextProps.translations) !== JSON.stringify(this.props.translations)) {
      this.setState({ translationService: new TranslationService(nextProps.translations) });
    };
    return true;
  };

  getHomePagecontent = () => {
    const spinnerId = uuid();
    this.props.addPageSpinner(spinnerId);
    ApiService.getHomePagecontent().then(response => {
      const data = { ...response.data };
      const pageContent = data.pageContent;
      const sliderContent = [...data.pageContentResponses];
      this._isMounted && this.setState({ pageContent, sliderContent });
      this.props.removePageSpinner(spinnerId);
    }).catch(error => this.getFail(error, spinnerId));
  };

  getCourses = () => {
    const spinnerId = uuid();
    this.props.addPageSpinner(spinnerId);
    ApiService.getHomeCourses().then(response => {
      const data = { ...response.data };
      this._isMounted && response.data && this.setState({
        topCourses: data.topCourses ? this.shuffle(data.topCourses) : [],
        recommendedCourses: data.recommendedCourses ? this.shuffle(data.recommendedCourses) : [],
        developmentCourses: data.developmentCourses ? this.shuffle(data.developmentCourses) : [],
        bestsellerCourses: data.bestsellerCourses ? this.shuffle(data.bestsellerCourses) : [],
      });
      this.props.removePageSpinner(spinnerId);
    }).catch(error => this.getFail(error, spinnerId));
  };

  shuffle = (array) => {
    let currentIndex = array.length, randomIndex;
    while (currentIndex !== 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex], array[currentIndex]];
    }
    return array;
  }

  updateCourses = (id) => {
    const { topCourses, developmentCourses, bestsellerCourses, recommendedCourses } = this.state;

    topCourses && topCourses.forEach(element => {
      if (element.id === id) {
        if (element.isInWishlist === true) {
          element.isInWishlist = false;
        } else {
          element.isInWishlist = true;
        }
      };
    });

    developmentCourses && developmentCourses.forEach(element => {
      if (element.id === id) {
        if (element.isInWishlist === true) {
          element.isInWishlist = false;
        } else {
          element.isInWishlist = true;
        }
      };
    });

    bestsellerCourses && bestsellerCourses.forEach(element => {
      if (element.id === id) {
        if (element.isInWishlist === true) {
          element.isInWishlist = false;
        } else {
          element.isInWishlist = true;
        }
      };
    });

    recommendedCourses && recommendedCourses.forEach(element => {
      if (element.id === id) {
        if (element.isInWishlist === true) {
          element.isInWishlist = false;
        } else {
          element.isInWishlist = true;
        }
      };
    });

    this.setState({ topCourses, developmentCourses, bestsellerCourses, recommendedCourses });
  }

  redirectToSliderUrlPage = (url) => {
    // window.location.href = url;
    this.props.history.push(`/${url}`);
  }

  getFail = (error, spinnerId) => {
    error && AlertService.alert((AlertService.checkMessageType(error.respcode) || ERROR_KEY), error);
    spinnerId && this.props.removePageSpinner(spinnerId);
  };

  render() {

    const { language, courseCategories } = this.props;
    const { pageContent, translationService, sliderContent, topCourses, recommendedCourses, developmentCourses, bestsellerCourses } = this.state;

    var recomendedCategories = [];
    var lastCategory = null;
    if (courseCategories.length % 2) lastCategory = courseCategories[courseCategories?.length - 1];

    const chunkArray = (arr, n) => {
      if (!arr || !n) { return; }
      var chunkLength = Math.max(arr.length / n, 1);
      var chunks = [];
      for (var i = 0; i < n; i++) {
        if (chunkLength * (i + 1) <= arr.length) chunks.push(arr.slice(chunkLength * i, chunkLength * (i + 1)));
      }
      lastCategory && chunks.push([lastCategory])
      return chunks;
    }
    recomendedCategories = chunkArray(courseCategories, courseCategories?.length / 2);
    return translationService ? <Auxiliary>
      <section className="container light-blue-background cover-image">
        <NukaCarousel
          autoplay={sliderContent && sliderContent.length > 1 ? true : false}
          wrapAround={true}
          autoplayInterval={4000}
          speed={1000}
        >
          {
            sliderContent && sliderContent.length ?
              sliderContent.map(content => {
                if (content.fullContent && content.fullContent.length) {
                  return <div key={content.id} className="d-flex align-items-center justify-content-around pb-4">
                    <div className="cover-text-wrapper">
                      <h1 className="cover-title">{JSON.parse(content.fullContent)?.title}<br /><span>{JSON.parse(content.fullContent)?.subtitle}</span></h1>
                      <p>{JSON.parse(content.fullContent)?.description}</p>
                      {
                        content.buttonLink ?
                          <Auxiliary>
                            <hr />
                            <button
                              type="button"
                              className="mindalay--btn mindalay--btn-dark cursor-pointer"
                              onClick={() => this.redirectToSliderUrlPage(content.buttonLink)}
                            >
                              {translationService.translate("TR_GET_STARTED")}
                            </button>
                          </Auxiliary>
                          : null
                      }
                    </div>
                    <img src={content.imagePath} />
                  </div>
                } else { return false; }
              })
              : null
          }
        </NukaCarousel>
      </section>
      <section className="section m-section">
        <div className="container py-3">
          <div className="row">
            <div className="col-12">
              <h1 className="section-title">{translationService.translate("TR_CATEGORIES")}</h1>
            </div>
            <div className="col-12">
              {
                recomendedCategories && recomendedCategories.length ?
                  <Carousel
                    responsive={responsiveCourses}
                    arrows={true}
                  // infinite={true}
                  >
                    {
                      recomendedCategories.map((recomendedCategory, index) => {
                        return <div key={index} className="d-flex flex-column mx-2 h-auto">
                          {
                            recomendedCategory.map(category => <Link
                              key={category.id}
                              to={`/${language}/${CATEGORY_KEY}/${category.id}`}
                              className="mindalay--btn-blue mindalay--btn-link w-100 h-100 my-1"
                            >
                              {category.name}
                            </Link>
                            )
                          }
                        </div>
                      })
                    }
                  </Carousel>
                  : null
              }
            </div>
          </div>
        </div>
        <div className="container py-3">
          <div className="row">
            {
              pageContent && JSON.parse(pageContent)?.title ?
                <div className="col-12">
                  <h1 className="section-title text-uppercase font-weight-bold">{JSON.parse(pageContent)?.title}</h1>
                </div>
                : null
            }
            <div className="col-12">
              {
                pageContent && JSON.parse(pageContent)?.description ?
                  <p>{JSON.parse(pageContent)?.description}</p>
                  : null
              }
            </div>
          </div>
        </div>
        {
          topCourses && topCourses.length ?
            <div className="container py-3">
              <hr />
              <div className="row">
                <div className="col-12">
                  <h1 className="section-title">{translationService.translate("TR_TOP_COURSES")}</h1>
                </div>
                <div className="col-12 course-carousel">
                  <Carousel
                    responsive={responsive}
                    arrows={true}
                  >
                    {topCourses.map(course =>
                      <CourseBlock
                        key={course.id}
                        course={course}
                        creatorId={course.creatorUserId}
                        updateCourses={this.updateCourses}
                      />)}
                  </Carousel>
                </div>
              </div>
            </div>
            : null
        }
        {
          recommendedCourses && recommendedCourses.length ?
            <div className="container py-3">
              <div className="row">
                <div className="col-12">
                  <h1 className="section-title">{translationService.translate("TR_RECOMMENDED_COURSES")}</h1>
                </div>
                <div className="col-12 course-carousel">
                  <Carousel
                    responsive={responsive}
                    arrows={true}
                  >
                    {recommendedCourses.map(course =>
                      <CourseBlock
                        key={course.id}
                        course={course}
                        creatorId={course.creatorUserId}
                        updateCourses={this.updateCourses}
                      />)}
                  </Carousel>
                </div>
              </div>
              <hr />
            </div>
            : null
        }
        <div className="light-gray-background py-3">
          <div className="container">
            <h1 className="section-title">{translationService.translate("TR_OUR_PARTNERS")}</h1>
            <div className="row">
              <div className="col-sm-6 col-md-4">
                <div className="square-holder"
                  title="CRYLLEX"
                  onClick={() => window.open("https://cryllex.com/", "_blank")}
                >
                  <img alt="/" src={cryllex} />
                </div>
              </div>
              <div className="col-sm-6 col-md-4">
                <div className="square-holder"
                  title="GET ME PET"
                  onClick={() => window.open("https://test.getmepet.com/", "_blank")}
                >
                  <img alt="/" src={getmepet} />
                </div>
              </div>
              <div className="col-sm-6 col-md-4">
                <div className="square-holder"
                  title="FRANTIXMEDIA"
                  onClick={() => window.open("https://frantixmedia.com/", "_blank")}
                >
                  <img alt="/" src={frantixmedia} />
                </div>
              </div>
            </div>
          </div>
        </div>
        {
          developmentCourses && developmentCourses.length ?
            <div className="container py-3">
              <div className="row">
                <div className="col-12">
                  <h1 className="section-title">{translationService.translate("TR_DEVELOPMENT_COURSES")}</h1>
                </div>
                <div className="col-12 course-carousel">
                  <Carousel
                    responsive={responsive}
                    arrows={true}
                  >
                    {developmentCourses.map(course =>
                      <CourseBlock
                        key={course.id}
                        course={course}
                        creatorId={course.creatorUserId}
                        updateCourses={this.updateCourses}
                      />)}
                  </Carousel>
                </div>
              </div>
            </div>
            : null
        }
        {
          bestsellerCourses && bestsellerCourses.length ?
            <div className="container py-3">
              <hr />
              <div className="row">
                <div className="col-12">
                  <h1 className="section-title">{translationService.translate("TR_BESTSELLERS")}</h1>
                </div>
                <div className="col-12 course-carousel">
                  <Carousel
                    responsive={responsive}
                    arrows={true}
                  >
                    {bestsellerCourses.map(course =>
                      <CourseBlock
                        key={course.id}
                        course={course}
                        creatorId={course.creatorUserId}
                        updateCourses={this.updateCourses}
                      />)}
                  </Carousel>
                </div>
              </div>
            </div>
            : null
        }
      </section>
    </Auxiliary > : null;
  }
}

const mapStateToProps = state => ({
  languages: state.language.languages,
  language: state.language.language,
  courseCategories: state.course.courseCategories,
  translations: state.translation.translations,
  user: state.user.user,
});

const mapDispatchToProps = {
  addButtonSpinner,
  removeButtonSpinner,
  addPageSpinner,
  removePageSpinner,
  setCurrentCourse,
  setPureLayoutBackUrl
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(Home);
